module.exports = __webpack_public_path__ + "img/firmador-cycle.c322ee97.webp";